// extracted by mini-css-extract-plugin
export default {"float":"styles_float__GYH9U","icon":"styles_icon__8hkI3"};